/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import styled from "styled-components";

const _Heading = styled.h1`
  margin: 0 0 16px 0;
  padding: 0;
  font-weight: var(--spectrum-global-font-weight-black);
  color: var(--spectrum-global-color-gray-900);
`;

export const Heading16 = styled.h4`
  font-size: 16px;
`;

export const Heading18 = styled(_Heading)`
  font-size: 18px;
  line-height: 22px;
`;

export const Heading22 = styled(_Heading)`
  font-size: 22px;
  line-height: 27px;
`;

export const Heading28 = styled(_Heading)`
  font-size: 28px;
  line-height: 40px;
`;

export const Heading28NoMargin = styled(_Heading)`
  font-size: 28px;
  line-height: 40px;
  margin: 0px;
`;

export const Heading32 = styled(_Heading)`
  font-size: 32px;
  line-height: 40px;
`;
